module.exports = __webpack_public_path__ + "img/20200508144748TIM截图20200508144701.e773d556.png";